export enum Color {
    violet = "#8F0DA9",
    grey = "#D8D8D8",
    lightGrey = "#EBEBEC",
    red = "#931100",
    black = "#000",
    pink = "#ea3f80",
    lightpink = "#ffd6e5"
}
